import React, { ChangeEvent, Component } from "react";
import ContextEnum from "../../../../../models/ContextEnum";
import ICreateAttributeDTO from "../../../../../models/DTO/ICreateAttributeDTO";
import ICreateCategoryDTO from "../../../../../models/DTO/ICreateCategoryDTO";
import IDeleteCategoryDTO from "../../../../../models/DTO/IDeleteCategoryDTO";
import IGetAttributesDTO from "../../../../../models/DTO/IGetAttributesDTO";
import IGetSubCategoriesDTO from "../../../../../models/DTO/IGetSubCategoriesDTO";
import IOnCreateAttributeDTO from "../../../../../models/DTO/IOnCreateAttributeDTO";
import IOnCreateCategoryDTO from "../../../../../models/DTO/IOnCreateCategoryDTO";
import IOnGetAttributes from "../../../../../models/DTO/IOnGetAttributes";
import IOnGetSubCategoriesDTO from "../../../../../models/DTO/IOnGetSubCategoriesDTO";
import IOnUpdateCategoryDTO from "../../../../../models/DTO/IOnUpdateCategoryDTO";
import IUpdateAttributeDTO from "../../../../../models/DTO/IUpdateAttributeDTO";
import IOnUpdateAttributesDTO from "../../../../../models/DTO/IOnUpdateAttributesDTO";
import EndpointsEnum from "../../../../../models/EndpointsEnum";
import IAttribute from "../../../../../models/IAttribute";
import ICatalog from "../../../../../models/ICatalog";
import ICategory from "../../../../../models/ICategory";
import * as _ from "lodash-es";
import "./CategoryAccordion.scss";
import INewCategory from "../../../../../models/INewCategory";
import IOrder from "../../../../../models/IOrder";
import IPrice_Group from "../../../../../models/IPrice_Group";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUserUI";
import IVendor_Source from "../../../../../models/IVendor_Source";
import IVendor_Source_Location from "../../../../../models/IVendor_Source_Location";
import UIService from "../../../../../services/UIService";
import OwButton from "../../../../shared/OwButton/OwButton";
import ChipSizeEnum from "../../../../shared/OwChips/ChipSizeEnum";
import OwChips from "../../../../shared/OwChips/OwChips";
import OwInputWrapper from "../../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";
import SupplierGuidEnum from "../../../../../models/SupplierGuidEnum";
import OwCheckbox from "../../../../shared/OwCheckbox/OwCheckbox";
import IUpdateCategoryDTO from "../../../../../models/DTO/IUpdateCategoryDTO";
import IErrorDTO from "../../../../../models/DTO/IErrorDTO";
import INotification from "../../../../../models/INotification";
import NotificationLevelEnum from "../../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../../models/NotificationPositionEnum";
import RestEndpointsEnum from "../../../../../models/RestEndpointsEnum";
import { buildRestUrl, buildAuthHeadersForFetch } from "../../../../../services/RestService";
import { DiscountAssignment } from "../../../../shared/DiscountAssignment/DiscountAssignment";
import WineService from "../../../../../services/WineService";
import IDiscount from "../../../../../models/IDiscount";
import { RatioItemsSelection } from "../RatioItemsSelection/RatioItemsSelection";
import IOnGetCategoryDTO from "../../../../../models/DTO/IOnGetCategoryDTO";
import IGetCategoryDTO from "../../../../../models/DTO/IGetCategoryDTO";
import { ConfirmDeleteOverlayFn } from "../../../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import { OwDeleteEditActions } from "../../../../shared/OwDeleteEditActions/OwDeleteEditActions";
import { OwAcceptCancelActions } from "../../../../shared/OwAcceptCancelActions/OwAcceptCancelActions";
import OwToggle from "@components/shared/OwToggle/OwToggle";
import { NumericFormat } from "react-number-format";
import AttributeTypeEnum from "../../../../../models/AttributeTypeEnum";
import OwDateInput from "../../../../shared/OwDateInput/OwDateInput";
import { IApplyAttributeDefaultDTO, IOnApplyAttributeDefaultDTO } from "../../../../../models/DTO/IApplyAttributeDefaultDTO";
import moment, { Moment } from "moment-timezone";

type Props = {
    category?: ICategory;
    createCategoryFn: (newCategory: INewCategory, options?: { discounts?: number[] }) => void;
    updateCategoryFn: (category: ICategory, options?: { discounts?: number[] }) => void;
    deleteCategoryFn?: (category: ICategory) => void;
    cancelCategoryFn: () => void;
    socket: Socket;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    catalogModel?: ICatalog;
    priceGroups?: IPrice_Group[];
    level: number;
    isSimpleCategories?: boolean;
    vendorSources?: IVendor_Source[];
    hideAttributes?: boolean;
    hideVendorSources?: boolean;
    hideEmails?: boolean;
    homeCategory?: boolean;
    takeOff?: IOrder;
    saveSubCategoryFn?: (newCategory: INewCategory, parentCategoryId: number) => void;
    subCategoryTitle?: string;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    index: number;
    idPrefix?: string;
};

type State = {
    category?: ICategory;
    isOpen: boolean;
    name?: string;
    note?: string;
    isSaveActive: boolean;
    attributes?: IAttribute[];
    attribute: string;
    subCategories?: ICategory[];
    allowAddAttributes: boolean;
    allowAddSubCategories: boolean;
    editMode: boolean;
    hide_category: boolean;
    rowRef: string | null;
    selectedVendorSource?: IVendor_Source | null;
    selectedVendorSourceLocation?: IVendor_Source_Location | null;
    selectedVendorSourceLocations: IVendor_Source_Location[];
    hasPendingLocationChanges: boolean;
    newEmail: string;
    email: string;
    discounts: number[];
    perform_tally: boolean;
    isAddingNYSLAAttributes: boolean;
    editingAttributeId: number | null;
    editingAttribute: Partial<IAttribute> | null;
    applyDefaultModalAttributeGuid: string | null;
    applyDefaultOnlyIfEmpty: boolean;
    isApplyingDefault: boolean;
};

class CategoryAccordion extends Component<Props, State> {
    MAX_CATEGORY_DEPTH = 4;

    readonly state: State = {
        isOpen: false,
        isSaveActive: false,
        attributes: [],
        attribute: "",
        subCategories: [],
        allowAddAttributes: true,
        allowAddSubCategories: true,
        hide_category: this.props.category ? this.props.category.hide_category || false : false,
        editMode: this.props.category?.guid ? false : true,
        name: this.props.category ? this.props.category.name : "",
        note: this.props.category ? this.props.category.note : "",
        email: this.props.category ? this.props.category.email || "" : "",
        category: this.props.category,
        selectedVendorSourceLocations: this.props.category?.Vendor_Source_Locations ? this.props.category?.Vendor_Source_Locations : [],
        hasPendingLocationChanges: false,
        newEmail: "",
        discounts: [],
        rowRef: null,
        perform_tally: this.props.category ? this.props.category.perform_tally || false : false,
        isAddingNYSLAAttributes: false,
        editingAttributeId: null,
        editingAttribute: null,
        applyDefaultModalAttributeGuid: null,
        applyDefaultOnlyIfEmpty: true,
        isApplyingDefault: false,
    };

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.CategoriesOnCreateCategory, this.onCreateCategory);
        this.props.socket.on(EndpointsEnum.Notify, this.notify);
        this.props.socket.on(EndpointsEnum.CategoriesOnGetAttributes, this.onGetAttributes);
        this.props.socket.on(EndpointsEnum.CategoriesOnCreateAttribute, this.onCreateAttribute);
        this.props.socket.on(EndpointsEnum.CategoriesOnGetSubCategories, this.onGetSubCategories);
        this.props.socket.on(EndpointsEnum.CategoriesOnUpdateCategory, this.onUpdateCategory);
        this.props.socket.on(EndpointsEnum.CategoriesOnGetCategory, this.onGetCategory);
        this.props.socket.on(EndpointsEnum.CategoriesOnUpdateAttribute, this.onUpdateAttribute);
        this.props.socket.on(EndpointsEnum.CategoriesOnApplyAttributeDefault, this.onApplyAttributeDefault);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnCreateCategory, this.onCreateCategory);
        this.props.socket.removeListener(EndpointsEnum.Notify, this.notify);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnGetAttributes, this.onGetAttributes);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnCreateAttribute, this.onCreateAttribute);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnGetSubCategories, this.onGetSubCategories);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnUpdateCategory, this.onUpdateCategory);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnGetCategory, this.onGetCategory);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnUpdateAttribute, this.onUpdateAttribute);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnApplyAttributeDefault, this.onApplyAttributeDefault);
    }

    notify = () => {
        this.setState({
            isSaveActive: false,
        });
    };

    onUpdateCategory = (data: IOnUpdateCategoryDTO) => {
        if (this.state.category && data.category && data.category.guid === this.state.category.guid) {
            this.setState({
                editMode: false,
                category: data.category,
                isSaveActive: false,
                hasPendingLocationChanges: false,
            });
        }
    };

    getCategory = () => {
        if (this.state.category) {
            const payload: IGetCategoryDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                categoryGuid: this.state.category?.guid,
            };

            this.props.socket.emit(EndpointsEnum.CategoriesGetCategory, payload);
        }
    };

    onGetCategory = (data: IOnGetCategoryDTO) => {
        this.setState({
            category: data.category,
        });
    };

    onCreateCategory = (data: IOnCreateCategoryDTO) => {
        const state: any = {
            isSaveActive: false,
        };

        if (!this.props.isSimpleCategories) {
            if (this.state.category && data.category.parent_category_id === this.state.category.id) {
                this.getSubCategories();
                state.allowAddSubCategories = true;
            }
        }

        this.setState(state);
    };

    onCreateAttribute = (data: IOnCreateAttributeDTO) => {
        this.setState(
            {
                isSaveActive: false,
                allowAddAttributes: true,
            },
            () => {
                if (this.state.category && data.attributes[0].category_id === this.state.category.id) {
                    this.getAttributes();
                }
            }
        );
    };

    onUpdateAttribute = (data: IOnUpdateAttributesDTO) => {
        // Refresh attributes list after update
        this.getAttributes();
        this.setState({ editingAttributeId: null, editingAttribute: null });
    };

    onApplyAttributeDefault = (data: IOnApplyAttributeDefaultDTO) => {
        // Only handle if this was our request
        if (data.attributeGuid === this.state.applyDefaultModalAttributeGuid) {
            const notification: INotification = {
                message: `Updated ${data.updated} items with default value for "${data.attributeName}"`,
                level: NotificationLevelEnum.success,
                position: NotificationPositionEnum.bc,
                skipMessageTranslate: true,
            };

            this.props.notifyFn(null, notification);

            this.setState({
                applyDefaultModalAttributeGuid: null,
                isApplyingDefault: false,
            });
        }
    };

    handleEditAttributeDefaultChange = (value: any) => {
        this.setState((prevState) => ({
            editingAttribute: {
                ...prevState.editingAttribute,
                default_value: value,
            },
        }));
    };

    showApplyDefaultConfirmation = (attributeGuid: string) => {
        this.setState({
            applyDefaultModalAttributeGuid: attributeGuid,
            applyDefaultOnlyIfEmpty: true,
        });
    };

    cancelApplyDefault = () => {
        this.setState({
            applyDefaultModalAttributeGuid: null,
        });
    };

    toggleApplyDefaultOnlyIfEmpty = (e: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            applyDefaultOnlyIfEmpty: e.target.checked,
        });
    };

    applyAttributeDefault = () => {
        if (!this.state.applyDefaultModalAttributeGuid) return;

        const payload: IApplyAttributeDefaultDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            attributeGuid: this.state.applyDefaultModalAttributeGuid,
            onlyIfEmpty: this.state.applyDefaultOnlyIfEmpty,
        };

        this.setState({ isApplyingDefault: true });
        this.props.socket.emit(EndpointsEnum.CategoriesApplyAttributeDefault, payload);
    };

    renderDefaultValueInput = (attribute: Partial<IAttribute>) => {
        const type = attribute.type || AttributeTypeEnum.TEXT;
        const value = this.state.editingAttribute?.default_value;

        switch (type) {
            case AttributeTypeEnum.TEXT:
                return (
                    <OwInputWrapper
                        name="default_value"
                        value={value || ""}
                        fn={(e: ChangeEvent<HTMLInputElement>) => this.handleEditAttributeDefaultChange(e.target.value)}
                        placeholder={"default_value"}
                    />
                );

            case AttributeTypeEnum.NUMBER:
                return (
                    <NumericFormat
                        className="form-control form-control-sm"
                        value={value || ""}
                        onValueChange={(values) => this.handleEditAttributeDefaultChange(values.floatValue)}
                        placeholder="Default Value"
                        thousandSeparator={true}
                        decimalScale={2}
                    />
                );

            case AttributeTypeEnum.DROPDOWN: {
                const options = (attribute.options || []).map((opt: string) => ({
                    value: opt,
                    label: opt,
                }));
                return (
                    <OwSelectOption
                        name="default_value"
                        options={options}
                        valueProp="value"
                        titleProp="label"
                        fn={(e: ChangeEvent<HTMLSelectElement>) => this.handleEditAttributeDefaultChange(e.target.value)}
                        selectedOption={value}
                        showBlankFirst={true}
                        hasSelectedOptionProp={false}
                    />
                );
            }

            case AttributeTypeEnum.BOOLEAN:
                return (
                    <OwCheckbox
                        checked={!!value}
                        fn={(e: ChangeEvent<HTMLInputElement>) => this.handleEditAttributeDefaultChange(e.target.checked)}
                        label={"default_value"}
                    />
                );

            case AttributeTypeEnum.DATE:
                return (
                    <OwDateInput
                        selectedDate={value ? new Date(value) : undefined}
                        fn={(date: Moment | null) => this.handleEditAttributeDefaultChange(date?.toISOString())}
                    />
                );

            default:
                return null;
        }
    };

    formatDefaultValueDisplay = (attribute: IAttribute): React.ReactNode => {
        if (_.isNil(attribute.default_value) || attribute.default_value === "") {
            return null;
        }

        let displayValue: string;

        switch (attribute.type) {
            case AttributeTypeEnum.BOOLEAN:
                displayValue = attribute.default_value ? "Yes" : "No";
                break;
            case AttributeTypeEnum.DATE:
                displayValue = moment(attribute.default_value).format("YYYY-MM-DD");
                break;
            default:
                displayValue = String(attribute.default_value);
        }

        return <span className={"ms-2 badge bg-info text-dark"}>Default: {displayValue}</span>;
    };

    startEditAttribute = (attribute: IAttribute) => {
        this.setState({
            editingAttributeId: attribute.id,
            editingAttribute: { ...attribute },
        });
    };

    cancelEditAttribute = () => {
        this.setState({
            editingAttributeId: null,
            editingAttribute: null,
        });
    };

    handleEditAttributeChange = (e: ChangeEvent<any>, field: string) => {
        const value = e.target.value;
        this.setState((prevState) => ({
            editingAttribute: {
                ...prevState.editingAttribute,
                [field]: value,
            },
        }));
    };

    handleEditAttributeHiddenChange = (e: ChangeEvent<any>) => {
        const value = e.target.checked;
        this.setState((prevState) => ({
            editingAttribute: {
                ...prevState.editingAttribute,
                is_hidden: value,
            },
        }));
    };

    saveEditedAttribute = () => {
        if (!this.state.editingAttribute || !this.state.category) return;

        const payload: IUpdateAttributeDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            attributes: [this.state.editingAttribute as IAttribute],
        };

        this.props.socket.emit(EndpointsEnum.CategoriesUpdateAttribute, payload);
    };

    handleNewAttributeHiddenChange = (e: ChangeEvent<any>) => {
        const attributes = this.state.attributes || [];
        if (attributes[0]) {
            attributes[0].is_hidden = e.target.checked;
            this.setState({ attributes });
        }
    };

    createAttributeStub = () => {
        return {
            name: "",
            is_hidden: false,
        };
    };

    addAttribute = () => {
        const attributes = this.state.attributes || [];

        const state: any = {
            attributes: [this.createAttributeStub(), ...attributes],
            allowAddAttributes: false,
        };

        this.setState(state);
    };

    addNYSLAAttributes = async () => {
        if (!this.state.category || !this.props.catalogModel) {
            return;
        }

        this.setState({ isAddingNYSLAAttributes: true });

        try {
            const url = buildRestUrl({
                endpoint: RestEndpointsEnum.WineNYSLAAttributes,
                params: { categoryGuid: this.state.category.guid },
            });

            const headers = buildAuthHeadersForFetch({
                userModel: this.props.userModel,
                supplierModel: this.props.supplierModel,
            });

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    ...headers,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    catalogId: this.props.catalogModel.id,
                }),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `Failed to create NYSLA attributes`);
            }

            // Refresh attributes list
            this.getAttributes();

            const notification: INotification = {
                message: "nysla_attributes_created",
                level: NotificationLevelEnum.success,
                position: NotificationPositionEnum.bc,
            };
            this.props.notifyFn(null, notification);
        } catch (error) {
            console.error("Error creating NYSLA attributes:", error);

            const notification: INotification = {
                message: error instanceof Error ? error.message : "nysla_attributes_creation_failed",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
                skipMessageTranslate: error instanceof Error,
            };
            this.props.notifyFn(null, notification);
        } finally {
            this.setState({ isAddingNYSLAAttributes: false });
        }
    };

    saveAttribute = () => {
        if (!this.state.category || !this.state.attributes) {
            return null;
        }

        const attributesArr = this.state.attributes[0];

        const payload: ICreateAttributeDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            attributes: [attributesArr!],
            categoryGuid: this.state.category.guid,
        };

        this.props.socket.emit(EndpointsEnum.CategoriesCreateAttribute, payload);

        this.setState({
            allowAddAttributes: false,
        });
    };

    cancelAttribute = () => {
        const attributes = this.state.attributes || [];
        attributes.shift();

        const state: any = {
            attributes,
            allowAddAttributes: true,
        };

        this.setState(state);
    };

    handleAttributeChange = (e: any, index: number) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        // const name = e.target.name;

        const attributes = this.state.attributes || [];

        attributes[0].name = value;

        const state: any = {
            attributes,
        };

        this.setState(state);
    };

    handleSubCategoryChange = (e: any, index: number) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        // const name = e.target.name;

        const subCategories = this.state.subCategories || [];

        subCategories[0].name = value;

        const state: any = {
            subCategories,
        };

        this.setState(state);
    };

    createSubCategoryStub = () => {
        return {
            name: "",
        };
    };

    addSubCategory = () => {
        const subCategories = this.state.subCategories || [];

        const state: any = {
            subCategories: [this.createSubCategoryStub(), ...subCategories],
            allowAddSubCategories: false,
        };

        this.setState(state);
    };

    saveSubCategory = () => {
        if (!this.state.category || !this.state.subCategories) {
            return null;
        }

        const subCategory = this.state.subCategories[0];

        if (this.props.saveSubCategoryFn) {
            this.props.saveSubCategoryFn(subCategory, this.state.category.id);
        } else {
            const payload: ICreateCategoryDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                parent_category_id: this.state.category.id,
                name: subCategory.name,
            };

            if (this.props.catalogModel) {
                payload.catalogGuid = this.props.catalogModel.guid;
            } else {
                if (!this.props.takeOff) {
                    payload.isVendorCategory = true;
                }
            }

            if (this.props.takeOff) {
                payload.isTakeOffCategory = true;
            }

            this.props.socket.emit(EndpointsEnum.CategoriesCreateCategory, payload);

            this.setState({
                allowAddSubCategories: false,
            });
        }
    };

    cancelSubCategory = () => {
        const subCategories = this.state.subCategories || [];
        subCategories.shift();

        const state: any = {
            subCategories,
            allowAddSubCategories: true,
        };

        this.setState(state);
    };

    getDiscountsDetail = () => {
        return !this.props.supplierModel.has_price_group_category_discounts ? null : (
            <div className={"mb-3"}>
                <OwTitle title={"price_group_discounts"} tag={"h6"} isBold={true} isUnderline={true} />
                {(this.props.priceGroups || []).map((priceGroup: IPrice_Group) => {
                    return (
                        <div key={priceGroup.guid}>
                            {priceGroup.value}:{" "}
                            {this.props.category?.price_group_discount ? this.props.category?.price_group_discount[priceGroup.value] : ""}%
                        </div>
                    );
                })}
            </div>
        );
    };

    selectVendorSource = (e: ChangeEvent<any>) => {
        if (this.props.vendorSources) {
            const value = e.target.value;

            const vendorSource = this.props.vendorSources.find((source) => {
                return Number(source.id) === Number(value);
            });

            this.setState({
                selectedVendorSource: vendorSource,
            });
        }
    };

    selectVendorSourceLocation = (e: ChangeEvent<any>) => {
        if (this.props.vendorSources && this.state.selectedVendorSource?.Vendor_Source_Locations) {
            const value = e.target.value;

            const vendorSourceLocation = this.state.selectedVendorSource.Vendor_Source_Locations.find((location) => {
                return Number(location.id) === Number(value);
            });

            this.setState({
                selectedVendorSourceLocation: vendorSourceLocation,
            });
        }
    };

    addLocation = () => {
        if (this.state.selectedVendorSourceLocation && this.state.selectedVendorSource) {
            const vendorLocation = this.state.selectedVendorSourceLocation;
            const vendorLocations = this.state.selectedVendorSourceLocations;

            if (!vendorLocation.Vendor_Source) {
                vendorLocation.Vendor_Source = this.state.selectedVendorSource;
            }

            vendorLocations.push(vendorLocation);

            this.setState({
                selectedVendorSourceLocations: vendorLocations,
                hasPendingLocationChanges: true,
            });
        }
    };

    removeLocation = (location: IVendor_Source_Location, index: number) => {
        if (this.state.selectedVendorSourceLocations) {
            const locations = this.state.selectedVendorSourceLocations;

            locations.splice(index, 1);

            this.setState({
                selectedVendorSourceLocations: locations,
                hasPendingLocationChanges: true,
            });
        }
    };

    addEmail = () => {
        let email = this.state.email;

        if (!email.length) {
            email += `${this.state.newEmail}`;
        } else {
            email += `,${this.state.newEmail}`;
        }

        this.setState({
            email,
        });
    };

    updateItemEmails = (e: string | string[]) => {
        const emails = _.isArray(e) ? e.join(",") : e;

        this.setState({
            email: emails,
        });
    };

    saveTakeOffQty = () => {
        if (this.state.category && this.state.category.guid) {
            this.props.updateCategoryFn(this.state.category);
        }
    };

    setDiscounts = (discounts: IDiscount[]) => {
        this.setState(
            {
                discounts: discounts.map((discount) => discount.id),
            },
            () => {
                if (this.state.category && this.state.category.guid) {
                    this.props.updateCategoryFn(this.state.category, { discounts: this.state.discounts });
                } else {
                    // Do nothing?
                }
            }
        );
    };

    refreshCategory = () => {
        this.getCategory();
    };

    getOpenedContent = () => {
        if (!this.state.isOpen || !this.state.category) {
            return null;
        }

        const attributes = _.map(this.state.attributes, (attribute, index) => {
            if (attribute.guid) {
                // Check if this attribute is being edited
                if (this.state.editingAttributeId === attribute.id) {
                    const hasDefaultValue =
                        !_.isNil(this.state.editingAttribute?.default_value) && this.state.editingAttribute?.default_value !== "";
                    const showApplyConfirm = this.state.applyDefaultModalAttributeGuid === attribute.guid;

                    return (
                        <div key={attribute.guid} className={"attribute-edit-row mb-2"}>
                            {/* System attribute info message */}
                            {attribute.is_system && (
                                <div className={"mb-2 text-muted small"}>
                                    <i className={"fas fa-info-circle me-1"}></i>
                                    System attributes cannot be renamed or have their visibility changed
                                </div>
                            )}

                            {/* Row 1: Name and Hidden toggle */}
                            <div className={"d-flex w-100 flex-row align-items-center mb-2"}>
                                <OwInputWrapper
                                    name={"name"}
                                    fn={(e: ChangeEvent<any>) => this.handleEditAttributeChange(e, "name")}
                                    value={this.state.editingAttribute?.name || ""}
                                    placeholder={"attribute"}
                                    disabled={attribute.is_system === true}
                                />
                                {attribute.is_system && (
                                    <span className={"ms-2 badge bg-warning text-dark"}>
                                        <i className={"fas fa-lock me-1"}></i>
                                        System
                                    </span>
                                )}
                            </div>

                            <div>
                                <OwToggle
                                    active={this.state.editingAttribute?.is_hidden || false}
                                    fn={this.handleEditAttributeHiddenChange}
                                    label={"hidden"}
                                    name={"is_hidden"}
                                    labelOnRight={true}
                                    disabled={attribute.is_system === true}
                                />
                            </div>

                            {/* Row 2: Default Value */}
                            <div className={"d-flex w-100 flex-column mb-2"}>
                                <div>
                                    <OwLabel title={"default_value"} className={"me-2"} noBottomMargin={true} />
                                </div>
                                <div>{this.renderDefaultValueInput(attribute)}</div>
                            </div>

                            {/* Row 3: Actions */}
                            <div className={"d-flex w-100 flex-row align-items-center"}>
                                <OwButton fn={this.saveEditedAttribute} title={"save"} className={"btn-primary"} />
                                <OwButton fn={this.cancelEditAttribute} title={"cancel"} className={"ms-2 btn-danger"} />

                                {/* Apply to Existing button - only if default is set */}
                                {hasDefaultValue && !showApplyConfirm && (
                                    <OwButton
                                        fn={() => this.showApplyDefaultConfirmation(attribute.guid)}
                                        title={"apply_to_existing"}
                                        className={"ms-2 btn-secondary"}
                                        leftIconClass={"fas fa-sync-alt"}
                                        disabled={this.state.isApplyingDefault}
                                    />
                                )}
                            </div>

                            {/* Inline confirmation for Apply */}
                            {showApplyConfirm && (
                                <div className={"apply-default-confirm mt-2 p-2 border rounded"}>
                                    <div className={"mb-2"}>
                                        <OwLabel title={"apply_default_confirm_message"} />
                                    </div>
                                    <OwCheckbox
                                        checked={this.state.applyDefaultOnlyIfEmpty}
                                        fn={this.toggleApplyDefaultOnlyIfEmpty}
                                        label={"only_apply_to_empty_values"}
                                        className={"mb-2"}
                                    />
                                    <div className={"d-flex"}>
                                        <OwButton
                                            fn={this.applyAttributeDefault}
                                            title={"apply"}
                                            className={"btn-primary"}
                                            active={this.state.isApplyingDefault}
                                            disableOnActive={true}
                                        />
                                        <OwButton fn={this.cancelApplyDefault} title={"cancel"} className={"ms-2 btn-secondary"} />
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                }

                // Display mode - show attribute with edit icon, system badge, hidden badge, and default value
                return (
                    <div key={attribute.guid} className={"d-flex align-items-center justify-content-between mb-1"}>
                        <div className={"d-flex align-items-center flex-wrap"}>
                            <span>{attribute.name}</span>
                            {attribute.is_system && (
                                <span className={"ms-2 badge bg-warning text-dark"}>
                                    <i className={"fas fa-lock me-1"}></i>
                                    System
                                </span>
                            )}
                            {attribute.is_hidden && (
                                <span className={"ms-2 badge bg-secondary"}>
                                    <i className={"fas fa-eye-slash me-1"}></i>
                                    Hidden
                                </span>
                            )}
                            {this.formatDefaultValueDisplay(attribute)}
                        </div>
                        <i className={"fas fa-pencil text-muted pointer ms-2"} onClick={() => this.startEditAttribute(attribute)} />
                    </div>
                );
            } else {
                // New attribute form with is_hidden toggle
                return (
                    <div key={`new-attr-${index}`} className={"d-flex w-100 flex-row align-items-center"}>
                        <OwInputWrapper
                            name={"attribute"}
                            fn={this.handleAttributeChange}
                            value={attribute?.name}
                            placeholder={"attribute"}
                        />
                        <OwCheckbox
                            checked={attribute?.is_hidden || false}
                            fn={this.handleNewAttributeHiddenChange}
                            label={"hidden"}
                            className={"ms-2"}
                        />
                        <OwButton fn={this.saveAttribute} title={"save"} className={"ms-2 btn-primary"} />
                        <OwButton fn={this.cancelAttribute} title={"cancel"} className={"ms-2 btn-danger"} />
                    </div>
                );
            }
        });

        const subCategories = _.map(this.state.subCategories, (subCategory, index) => {
            if (subCategory.guid) {
                let level = this.props.level;
                ++level;

                let idPrefix = "-sub";

                if (this.props.idPrefix) {
                    idPrefix = `${this.props.idPrefix}-sub`;
                }
                // console.log("Level: ", level);
                /**
                 *
                 */
                return (
                    <div key={subCategory.guid}>
                        <CategoryAccordion
                            createCategoryFn={this.props.createCategoryFn}
                            cancelCategoryFn={this.props.cancelCategoryFn}
                            updateCategoryFn={this.props.updateCategoryFn}
                            socket={this.props.socket}
                            userModel={this.props.userModel}
                            supplierModel={this.props.supplierModel}
                            catalogModel={this.props.catalogModel}
                            priceGroups={this.props.priceGroups}
                            category={subCategory}
                            level={level}
                            vendorSources={this.props.vendorSources}
                            isSimpleCategories={this.props.isSimpleCategories}
                            hideAttributes={this.props.hideAttributes}
                            hideEmails={this.props.hideEmails}
                            hideVendorSources={this.props.hideVendorSources}
                            takeOff={this.props.takeOff}
                            saveSubCategoryFn={this.props.saveSubCategoryFn}
                            subCategoryTitle={this.props.subCategoryTitle}
                            notifyFn={this.props.notifyFn}
                            index={index}
                            idPrefix={idPrefix}
                        />
                    </div>
                );
            } else {
                return (
                    <div className={"d-flex w-100 flex-row"}>
                        <OwInputWrapper
                            name={"name"}
                            fn={this.handleSubCategoryChange}
                            value={subCategory?.name}
                            placeholder={"category"}
                        />
                        <OwButton fn={this.saveSubCategory} title={"save"} className={"ms-2 btn-primary"} />
                        <OwButton fn={this.cancelSubCategory} title={"cancel"} className={"ms-2 btn-danger"} />
                    </div>
                );
            }
        });

        return (
            <div className={"content-section border "}>
                <div className="mb-2">
                    <div className="mb-2">
                        <OwToggle
                            fn={this.handleHideCategoryChange}
                            name={"hide_category"}
                            active={this.state.hide_category}
                            showDisableConfirm={false}
                            labelOnRight={true}
                            label={"hide_category"}
                        />
                    </div>

                    {this.props.supplierModel.has_category_tally && (
                        <div className="mb-2">
                            <OwToggle
                                fn={this.handleHideCategoryChange}
                                name={"perform_tally"}
                                active={this.state.perform_tally}
                                showDisableConfirm={false}
                                labelOnRight={true}
                                label={"perform_tally"}
                            />
                        </div>
                    )}

                    <hr />
                </div>

                {this.getDiscountsDetail()}

                {this.props.supplierModel.has_discounts ? (
                    <div className="mt-2 mb-2">
                        <div>
                            <OwLabel title={"discounts"} leftIconClass={"fad fa-dollar"} />
                        </div>
                        <div>
                            <DiscountAssignment
                                socket={this.props.socket}
                                setDiscounts={this.setDiscounts}
                                selectedDiscounts={this.props.category?.Discounts || []}
                                maxAllowed={1}
                            />
                        </div>
                        <hr />
                    </div>
                ) : null}

                {this.props.hideEmails || this.props.supplierModel.guid !== SupplierGuidEnum.LMC ? null : (
                    <div>
                        <div className={"d-flex mb-2 align-items-center"}>
                            <OwLabel title={"email"} noBottomMargin={true} />
                            <div>
                                <OwButton
                                    title={"save"}
                                    fn={this.saveCategory}
                                    active={this.state.isSaveActive}
                                    disableOnActive={true}
                                    className={"ms-2 btn-primary mt-1"}
                                />
                            </div>
                        </div>
                        <div className={"input-group mb-2"}>
                            <OwInputWrapper
                                placeholder={"email"}
                                name={"newEmail"}
                                fn={(e: any) => {
                                    this.handleChange(e);
                                }}
                                value={this.state.newEmail}
                            />
                            <div className={"input-group-append"}>
                                <OwButton
                                    title={"add"}
                                    fn={(e) => {
                                        this.addEmail();
                                    }}
                                />
                            </div>
                        </div>
                        <OwChips
                            chips={this.state.email}
                            updatedFn={(e) => {
                                this.updateItemEmails(e);
                            }}
                            context={ContextEnum.PRIMARY}
                            isStacked={true}
                            chipSize={ChipSizeEnum.XS}
                        />
                    </div>
                )}

                {this.props.takeOff ? (
                    <div className={"mb-4"}>
                        <div className={"mb-2"}>
                            <OwLabel title={"take_off_qty"} noBottomMargin={true} />
                            <OwButton title={"save"} fn={this.saveTakeOffQty} className={"ms-3 btn-primary"} />
                        </div>
                        <OwInputWrapper name={"takeoff_qty"} fn={this.handleCategoryChange} value={this.state.category.takeoff_qty || 0} />
                    </div>
                ) : null}

                {/*<div>*/}
                {/*    <OwLabel title={"note"} noBottomMargin={true} />*/}
                {/*    <OwTextArea name={"note"} value={this.state.note} fn={this.handleChange} />*/}
                {/*    <OwButton*/}
                {/*        title={"save_note"}*/}
                {/*        fn={this.saveCategory}*/}
                {/*        active={this.state.isSaveActive}*/}
                {/*        disableOnActive={true}*/}
                {/*        className={"ms-auto btn-primary mt-1"}*/}
                {/*    />*/}
                {/*</div>*/}

                {this.props.supplierModel.has_purchase_orders &&
                this.props.supplierModel.guid === SupplierGuidEnum.LMC &&
                !this.props.hideVendorSources ? (
                    <div>
                        <hr />

                        <div>
                            <OwLabel title={"vendor_source_locations"} isBold={true} />
                        </div>
                        <div className={"mb-2"}>
                            <OwSelectOption
                                name={"vendorSource"}
                                options={this.props.vendorSources || []}
                                titleProp={"name"}
                                valueProp={"id"}
                                selectedOption={this.state.selectedVendorSource}
                                selectedOptionProp={"id"}
                                showBlankFirst={true}
                                fn={this.selectVendorSource}
                            />
                            <OwSelectOption
                                name={"vendorSourceLocation"}
                                options={this.state.selectedVendorSource?.Vendor_Source_Locations || []}
                                titleProp={"name"}
                                valueProp={"id"}
                                selectedOption={this.state.selectedVendorSourceLocation}
                                selectedOptionProp={"id"}
                                fn={this.selectVendorSourceLocation}
                                isDisabled={!this.state.selectedVendorSource}
                                showBlankFirst={true}
                            />
                            <OwButton title={"add"} fn={this.addLocation} />
                        </div>

                        <div>
                            {this.state.hasPendingLocationChanges ? (
                                <div>
                                    <OwLabel title={"pending_changes"} className={"me-2"} />
                                    <OwButton title={"save"} fn={this.saveCategory} />
                                </div>
                            ) : null}
                        </div>

                        <div>
                            <table
                                className={
                                    "table " +
                                    (UIService.getThemeType(this.props.supplierModel, this.props.userModel).themeType === "LIGHT"
                                        ? ""
                                        : "table-dark")
                                }>
                                <tbody>
                                    {(this.state.selectedVendorSourceLocations || []).map((location, index: number) => {
                                        return (
                                            <tr key={location.guid}>
                                                <td>
                                                    <i
                                                        className={"me-2 fas fa-times text-danger pointer"}
                                                        onClick={() => {
                                                            this.removeLocation(location, index);
                                                        }}
                                                    />
                                                    {location.Vendor_Source?.name}
                                                </td>
                                                <td>{location?.name}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <hr />
                    </div>
                ) : null}

                {this.props.supplierModel.has_ratio_items && this.props.catalogModel ? (
                    <RatioItemsSelection
                        catalogGuid={this.props.catalogModel.guid}
                        category={this.state.category}
                        refreshCategory={this.refreshCategory}
                    />
                ) : null}

                {this.props.supplierModel.hide_category_attributes || this.props.hideAttributes ? null : (
                    <div>
                        <div className={"d-flex w-100 align-items-center"}>
                            <OwTitle title={"attributes"} tag={"h6"} isBold={true} isUnderline={true} />
                            <div className={"d-flex"}>
                                <OwButton
                                    centerIconClass={"far fa-plus"}
                                    className={"btn-primary ms-2"}
                                    fn={this.addAttribute}
                                    disabled={!this.state.allowAddAttributes}
                                />
                                {WineService.isNYSLAEligibleSupplier(this.props.supplierModel) &&
                                    this.props.supplierModel.Supplier_Integration?.has_nysla &&
                                    this.state.category?.guid && (
                                        <OwButton
                                            title={"add_nysla_attributes"}
                                            className={"btn-secondary ms-2"}
                                            fn={this.addNYSLAAttributes}
                                            active={this.state.isAddingNYSLAAttributes}
                                            disableOnActive={true}
                                        />
                                    )}
                            </div>
                        </div>
                        {attributes}
                        <hr />
                    </div>
                )}

                <div className={"d-flex w-100"}>
                    <OwTitle title={this.props.subCategoryTitle || "subcategories"} tag={"h6"} isBold={true} isUnderline={true} />
                    <div className={this.props.level < this.MAX_CATEGORY_DEPTH ? "" : "d-none"}>
                        <OwButton
                            centerIconClass={"far fa-plus"}
                            className={"btn-primary ms-2"}
                            fn={this.addSubCategory}
                            disabled={!this.state.allowAddSubCategories}
                        />
                    </div>
                </div>
                {subCategories}
                <hr />
            </div>
        );
    };

    toggleAccordion = () => {
        if (
            !this.state.category ||
            !this.state.category.guid ||
            this.props.isSimpleCategories ||
            this.state.editMode ||
            this.props.homeCategory
        ) {
            return null;
        }

        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            () => {
                if (this.state.isOpen) {
                    this.getAttributes();
                    this.getSubCategories();
                }
            }
        );
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    handleHideCategoryChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state, () => {
            this.updateCategoryHiddenFlag();
        });
    };

    updateCategoryHiddenFlag = () => {
        if (this.state.category) {
            const payload: IUpdateCategoryDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                hide_category: this.state.hide_category,
                perform_tally: this.state.perform_tally,
                categoryGuid: this.state.category.guid,
            };

            this.props.socket.emit(EndpointsEnum.CategoriesUpdateCategory, payload);
        }
    };

    handleCategoryChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const category = this.state.category;

        // @ts-expect-error
        category[name] = value;

        this.setState({
            category,
        });
    };

    getAttributes = () => {
        if (!this.state.category) {
            return null;
        }

        const payload: IGetAttributesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            categoryGuid: this.state.category.guid,
        };

        this.props.socket.emit(EndpointsEnum.CategoriesGetAttributes, payload);
    };

    onGetAttributes = (data: IOnGetAttributes) => {
        if (data && this.state.category && data.categoryGuid === this.state.category.guid) {
            this.setState({
                attributes: data.attributes,
            });
        }
    };

    getSubCategories = () => {
        if (!this.state.category || !this.state.category.guid) {
            return null;
        }

        const payload: IGetSubCategoriesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            parentCategoryGuid: this.state.category.guid,
        };

        this.props.socket.emit(EndpointsEnum.CategoriesGetSubCategories, payload);
    };

    onGetSubCategories = (data: IOnGetSubCategoriesDTO) => {
        if (this.state.category && this.state.category.guid === data.parentCategoryGuid) {
            this.setState({
                subCategories: data.categories,
            });
        }
    };

    saveCategory = () => {
        if (this.state.category && this.state.category.guid) {
            const updateCategory: ICategory = {
                ...this.state.category,
                name: this.state.name || "",
                note: this.state.note,
                email: this.state.email,
            };

            if (this.state.selectedVendorSourceLocations) {
                updateCategory.Vendor_Source_Locations = this.state.selectedVendorSourceLocations;
            }

            this.props.updateCategoryFn(updateCategory);

            this.setState({
                isSaveActive: true,
            });
        } else {
            const newCategory = {
                name: this.state.name,
                note: this.state.note,
                email: this.state.email,
            } as INewCategory;

            this.props.createCategoryFn(newCategory);

            this.setState({
                name: "",
                isSaveActive: true,
            });
        }
    };

    cancel = () => {
        if (this.state.category) {
            this.setState({
                editMode: false,
            });
        } else {
            this.props.cancelCategoryFn();
        }
    };

    toggleEditMode = () => {
        this.setState({
            editMode: true,
        });
    };

    /**
     * This function setups the Accordion Bar with the content - Title and Chevron if existing
     *
     */
    getTitleContent = () => {
        if (this.state.category && this.state.category.guid && !this.state.editMode) {
            let chevronIcon = "fas fa-chevron-up";

            if (this.state.isOpen) {
                chevronIcon = "fas fa-chevron-down";
            }

            if (this.props.isSimpleCategories) {
                chevronIcon = "";
            }

            const name = _.get(this.state, "category.name", "New");

            if (this.props.homeCategory) {
                return <>{name}</>;
            } else {
                return (
                    <>
                        {name} <i className={chevronIcon}></i>
                    </>
                );
            }
        } else {
            // Show the input, it's a new item!
            return (
                <>
                    <OwInputWrapper name={"name"} fn={this.handleChange} value={this.state.name} placeholder={"name"} />
                    {/*<OwButton fn={this.saveCategory} title={"save"} className={"ms-2 btn-primary"} />*/}
                    {/*<OwButton fn={this.cancel} title={"cancel"} className={"ms-2 btn-danger"} />*/}
                </>
            );
        }
    };

    toggleConfirmDelete = () => {
        let rowRef = `category-row-${this.props.index}`;

        if (this.props.idPrefix) {
            rowRef = `${this.props.idPrefix}-${rowRef}`;
        }

        console.log("toggleConfirmDelete: ", rowRef);

        this.setState({
            rowRef,
        });
    };

    cancelDelete = () => {
        this.setState({
            rowRef: null,
        });
    };

    commitDelete = () => {
        if (!this.props.deleteCategoryFn) {
            const payload: IDeleteCategoryDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                categoryGuid: this.state.category!.guid,
            };

            this.props.socket.emit(EndpointsEnum.CategoriesDeleteCategory, payload);
        } else {
            this.props.deleteCategoryFn(this.state.category!);
        }
    };

    render() {
        if (!this.state.category) {
            return null;
        }

        const isNew = !this.state.category.guid;

        return (
            <div className="CategoryAccordion position-relative">
                <ConfirmDeleteOverlayFn
                    targetElem={this.state.rowRef}
                    handleConfirm={this.commitDelete}
                    handleCancel={this.cancelDelete}
                    message={"confirm_delete_category"}
                    skipMainView={true}
                    nestedParentElem={`category-row-${this.props.index}`}
                />

                <div
                    className={"d-flex w-100 flex-column position-relative"}
                    id={
                        this.props.idPrefix ? `${this.props.idPrefix}-category-row-${this.props.index}` : `category-row-${this.props.index}`
                    }>
                    <div className={"title-row align-items-center d-flex"}>
                        <OwDeleteEditActions
                            isEditMode={this.state.editMode}
                            onTrashClickFn={this.toggleConfirmDelete}
                            onEditClickFn={this.toggleEditMode}
                            className={this.state.editMode ? "" : "me-2"}
                        />
                        <OwAcceptCancelActions
                            isEditMode={!this.state.editMode}
                            onAcceptClickFn={this.saveCategory}
                            onCancelClickFn={this.cancel}
                            className={this.state.editMode ? "me-2" : ""}
                        />
                        <div
                            className={
                                "d-flex w-100 justify-content-between  " +
                                (isNew ? "is-new" : "") +
                                (this.props.isSimpleCategories || this.props.homeCategory ? "" : "pointer")
                            }
                            onClick={(e: any) => {
                                this.toggleAccordion();
                            }}>
                            {this.getTitleContent()}
                        </div>
                    </div>

                    {this.getOpenedContent()}
                </div>
            </div>
        );
    }
}

export default CategoryAccordion;
